import type { OrderCounts } from '@/types/order-list';

export const membershipOrderPreviewCounts = {
  newOrderCount: 29,
  shippingReadyCount: 21,
  shippingCount: 4,
  shippingCompletedCount: 78,
  cancelRequestCount: 2,
  exchangeRequestCount: 2,
  returnRequestCount: 4,
} satisfies OrderCounts;

export const membershipDashboardOrderStatusSummary = [
  { statusName: '신규 주문', orderCount: membershipOrderPreviewCounts.newOrderCount },
  { statusName: '배송 준비', orderCount: membershipOrderPreviewCounts.shippingReadyCount },
  { statusName: '배송중', orderCount: membershipOrderPreviewCounts.shippingCount },
  { statusName: '배송완료', orderCount: membershipOrderPreviewCounts.shippingCompletedCount },
  { statusName: '취소요청', orderCount: membershipOrderPreviewCounts.cancelRequestCount },
  { statusName: '반품요청', orderCount: membershipOrderPreviewCounts.returnRequestCount },
  { statusName: '교환요청', orderCount: membershipOrderPreviewCounts.exchangeRequestCount },
];
